import { FaberApi, JetpacPayApi } from "api"

class CatalogAPI {
  /**
   * to list all available plans within the shop / catalog
   */
  static getCatalogPlans() {
    return FaberApi.httpGet('/catalog/esim/plans')
  }

  /**
   * to list all faber travel products
   */

  static getAllFaberCatalogPlans(
    faberToken: string,
    limit: number,
    offset: number,
    filterParams: FilterParamsProps
  ) {
    let queryParams = ''

    // if filter params are added
    if (Object.keys(filterParams).length > 0) {
      // add to queryparams
      for (const filterKey in filterParams) {
        queryParams += `&${filterKey}=${filterParams[filterKey]}`
      }
    }

    // if no filter or sort params, just fetch up to limit and as per offset
    return FaberApi.httpGet(
      `/catalog/item/detail?limit=${limit}&offset=${offset}${queryParams}`,
      {
        Authorization: `Bearer ${faberToken}`
      }
    ).then((res) => res.data)
  }

  static async createTelnaPackage(body: PackageModel) {
    return FaberApi.httpPost(
      `/orbit/catalog/ops/vendor/telna/package`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static async getAllCatalogItems(faberToken: string) {
    return FaberApi.httpGet(
      `/orbit/catalog/ops/item`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data.body.data)
  }

  static async getAllTelnaPackages(faberToken: string) {
    return FaberApi.httpGet(
      `/orbit/catalog/ops/vendor/telna/package`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }

  static async createCatalogItem(body: CatalogModel) {
    return FaberApi.httpPost(
      `/orbit/catalog/ops/item`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static async updateCatalogPrice(body: CatalogPriceModel) {
    return JetpacPayApi.httpPost(
      `/SGP/ops/stripe/price`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }
   static async getAllProvisionMethods(faberToken: string) {
    return FaberApi.httpGet(
      `/orbit/catalog/ops/provisionmethods`,
      { 
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async getAllCatalogPages(faberToken: string) {
    return FaberApi.httpGet(
      `/orbit/catalog/ops/pages/all`,
      { 
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async createCatalogPage(body: CatalogPage[]) {
    return FaberApi.httpPost(
      `/orbit/catalog/ops/pages/item`,
      {
        Authorization: `Bearer ${body[0].faberToken}`
      },
      body
    )
  }
  static async archiveCatalogFormPage(faberToken: string, pageFkCatalogId: string ) {
    return FaberApi.httpDelete(
      `/orbit/catalog/ops/pages/fk_catalog/${pageFkCatalogId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
    ).then((res) => res)
  }
  static async getAllCatalogItemsById(faberToken: string, id:string) {
    return FaberApi.httpGet(
      `/orbit/catalog/ops/pages/${id}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async AddFkCatalog(body: PageFkCatalog[]) {
    return FaberApi.httpPost(
      `/orbit/catalog/ops/pages/fk_catalog`,
      {
        Authorization: `Bearer ${body[0].faberToken}`
      },
      body
    )
  }
}
export default CatalogAPI
export interface FilterParamsProps {
  orderBy?: string
  isBonus?: boolean
  isRollover?: boolean
  isTopup?: boolean
  isBase?: boolean
  showClient?: boolean
}

export interface PackageModel {
  name: string
  trafficPolicyId: number
  supportedCountries: string[]
  preferredImsiId: number
  voiceUsageAllowanceInSeconds: number
  dataUsageAllowanceInBytes: number
  smsUsageAllowanceInNums: number
  timeAllowanceInSeconds: number
  activationTimeAllowanceInSeconds: number
  activationType: string
  dateEarliestActivation: number
  dateEarliestAvailable: number
  dateLatestAvailable: number
  notes: string
  dataUsageAllowanceType: string
  voiceUsageAllowanceType: string
  smsUsageAllowanceType: string
  faberToken: string
}

export interface CatalogModel {
  packageTypeRef: string
  vendor: string
  tenant: string
  name: string
  description: string[]
  callout?: string
  currency: string
  value: string
  symbol: string
  dataInGB: number
  voiceInMins: number
  SMS: number
  validityInDays: number
  image?: string
  countries: string[]
  packageType: string
  showClient: boolean
  redirectUrl?: string
  faberToken: string
}

export interface CatalogPriceModel {
  catalog_id: string
  currency: string
  unit_amount: number
  faberToken: string
}

export interface CatalogPage {
  name: string
  displayName:string
  destinationType:string
  faberToken: string 
}
export interface PageFkCatalog {
  catalogPageID: string
  catalogID: string
  faberToken:string
}